import {GetRefundBeneficiaryBankData} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetBeneficiaryBankData} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundBeneficiaryBankData = (): GetRefundBeneficiaryBankData =>
	new RemoteRefundGetBeneficiaryBankData(
		makeBFFApiUrl(RefundFlowEndPoints.beneficiaryBankData),
		makeAuthorizeHttpClientDecorator(),
	);
